import { Link } from "react-router-dom";
import { ArrowRight, Target, BarChart3, Mail, FileSpreadsheet, ShieldCheck, Star, Sparkles, ChevronRight, Globe, Zap, Users, TrendingUp, FlaskConical } from "lucide-react";
import { Button } from "@/components/ui/button";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";

const HEADSHOT_1 = "https://images.unsplash.com/photo-1651684215020-f7a5b6610f23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzc4MDAyNDc0fDA&ixlib=rb-4.1.0&q=85";
const HEADSHOT_2 = "https://images.unsplash.com/photo-1762522927402-f390672558d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHNtaWxpbmd8ZW58MHx8fHwxNzc4MDAyNDc0fDA&ixlib=rb-4.1.0&q=85";
const HEADSHOT_3 = "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=400";

const TRUST = ["NORTHWIND", "MERIDIAN", "AXIOM LABS", "PROXIMA", "VANGUARD", "SUMMIT", "OBELISK", "QUANTAVIA"];

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] text-[#0A0A0F]">
      <MarketingHeader />

      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 dot-bg opacity-50 pointer-events-none" />
        <div className="absolute top-1/4 right-0 w-[600px] h-[600px] rounded-full bg-[#002FA7]/5 blur-3xl pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-24">
          <div className="max-w-3xl mx-auto text-center fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-[#EAEAE3] shadow-soft mb-8 text-xs font-medium text-[#5C5C66]">
              <span className="w-1.5 h-1.5 rounded-full bg-[#16A34A] pulse-dot" />
              7 AI-powered tools — leads to replies, all in one workspace
            </div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.98]">
              Pipeline that<br />
              <span className="relative inline-block">
                writes itself.
                <svg className="absolute -bottom-3 left-0 w-full" height="14" viewBox="0 0 300 14" fill="none">
                  <path d="M2 9C50 4 100 4 150 7C200 10 250 6 298 4" stroke="#002FA7" strokeWidth="3" strokeLinecap="round" />
                </svg>
              </span>
            </h1>
            <p className="mt-9 text-lg sm:text-xl text-[#5C5C66] max-w-2xl mx-auto leading-relaxed">
              The complete B2B prospecting stack. Scrape decision-makers, enrich your lists, catch funding signals, run drip sequences, and track every open and reply — all from one workspace.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/signup" data-testid="hero-cta-primary">
                <Button className="rounded-lg h-12 px-7 bg-[#0A0A0F] hover:bg-[#14141B] text-white text-base font-medium shadow-soft-md">
                  Start free trial <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Link to="/pricing" data-testid="hero-cta-secondary">
                <Button variant="outline" className="rounded-lg h-12 px-7 border-[#EAEAE3] bg-white hover:bg-[#F4F4EE] text-base font-medium">
                  See pricing
                </Button>
              </Link>
            </div>
            <div className="mt-8 flex items-center justify-center gap-6 text-xs text-[#5C5C66]">
              <span className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-[#16A34A]" /> 50 free leads</span>
              <span className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-[#16A34A]" /> No credit card</span>
              <span className="flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5 text-[#16A34A]" /> Cancel anytime</span>
            </div>
          </div>

          {/* Product preview card */}
          <div className="mt-20 max-w-5xl mx-auto fade-in-up" style={{ animationDelay: "0.2s" }}>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#002FA7]/10 via-transparent to-[#FF5722]/10 blur-2xl rounded-3xl" />
              <div className="relative bg-white border border-[#EAEAE3] rounded-2xl shadow-soft-lg overflow-hidden">
                <div className="flex items-center gap-1.5 px-5 py-3 border-b border-[#EAEAE3] bg-[#FAFAF7]">
                  <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
                  <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
                  <div className="ml-4 text-xs text-[#9A9AA3] font-mono">leadsb2b.app/dashboard</div>
                </div>
                <div style={{ position: "relative", paddingBottom: "64.6%", height: 0 }}>
                  <iframe src="https://app.supademo.com/embed/cmp1i81t902jah3ibd0mrl74c" frameBorder="0" allowFullScreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust strip */}
      <section className="border-y border-[#EAEAE3] py-10 overflow-hidden bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center text-xs font-mono uppercase tracking-[0.25em] text-[#9A9AA3] mb-6">Trusted by revenue teams at</div>
          <div className="overflow-hidden">
            <div className="marquee-track text-[#9A9AA3] font-display font-bold text-2xl tracking-tight">
              {[...TRUST, ...TRUST].map((b, i) => (
                <span key={i} className="opacity-70 hover:opacity-100 transition-opacity">{b}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features — core */}
      <section id="features" className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl mb-16">
            <div className="label-mono mb-3">— Capabilities</div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight leading-tight">
              Everything your team needs.<br />
              <span className="text-[#5C5C66]">One pipeline.</span>
            </h2>
            <p className="mt-6 text-[#5C5C66] text-lg leading-relaxed">
              Stop juggling five tools. LeadsB2B covers the full motion — discovery, enrichment, sequencing, sending, and analytics — under one professional workspace.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mb-4">
            <FeatureCard
              span="md:col-span-7 md:row-span-2"
              icon={<Target className="h-5 w-5" />}
              kicker="01 / Discovery"
              title="AI prospect generation"
              body="Describe your ideal customer in plain English. Our AI surfaces qualified prospects matching your brief — name, role, company, email, intent signals — every record scored 1–100 against your ICP."
              feature
            />
            <FeatureCard
              span="md:col-span-5"
              icon={<BarChart3 className="h-5 w-5" />}
              kicker="02 / Scoring"
              title="Live ICP scoring"
              body="Every lead gets a fit score and pain-point summary. Sort, filter, prioritise — never miss a 90+."
            />
            <FeatureCard
              span="md:col-span-5"
              icon={<Mail className="h-5 w-5" />}
              kicker="03 / Outreach"
              title="Personalised cold emails"
              body="One click drafts a tone-tuned, 150-word cold email referencing the prospect's company, role and likely pain points."
            />
            <FeatureCard
              span="md:col-span-5"
              icon={<FileSpreadsheet className="h-5 w-5" />}
              kicker="04 / Import"
              title="Drop in your CSVs"
              body="Already have a list? Upload it, personalise outreach for every row, send through your verified domain."
            />
            <FeatureCard
              span="md:col-span-7"
              icon={<Sparkles className="h-5 w-5" />}
              kicker="05 / Send"
              title="Native sending via Resend"
              body="Connect your Resend account once. Send drafts one-by-one or hit Send All to ship the whole campaign — replies route back to your inbox."
              feature
            />
          </div>

          {/* Lead gen tools grid */}
          <div className="mt-16">
            <div className="label-mono mb-8">— Lead generation toolkit</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              <ToolCard
                icon={<Globe className="h-5 w-5" />}
                color="bg-[#002FA7]"
                title="Domain Scraper"
                body="Paste any company domain — our AI instantly surfaces the key decision-makers, enriches their profiles with emails and LinkedIn URLs, and adds them straight to your campaign."
              />
              <ToolCard
                icon={<Sparkles className="h-5 w-5" />}
                color="bg-[#7C3AED]"
                title="Smart CSV Enrichment"
                body="Upload a partial lead list and let AI fill in everything that's missing — emails, titles, LinkedIn profiles, ICP scores, summaries, and pain points — in seconds."
              />
              <ToolCard
                icon={<Zap className="h-5 w-5" />}
                color="bg-[#FF5722]"
                title="Trigger Events"
                body="Surface companies that just raised funding or are actively hiring. These are your highest-intent buyers — they have budget, they're growing, and they're looking for solutions."
              />
              <ToolCard
                icon={<Users className="h-5 w-5" />}
                color="bg-[#0D9488]"
                title="Lookalike Search"
                body='Mark a lead as qualified and hit "Find lookalikes" — AI analyses their company profile and surfaces 10 similar companies that match the same buying pattern.'
              />
              <ToolCard
                icon={<Mail className="h-5 w-5" />}
                color="bg-[#0284C7]"
                title="Drip Sequences"
                body="Build multi-step outreach sequences once and let them run. Define tone, delay, and offer per step — AI drafts every email for every lead in the campaign automatically."
              />
              <ToolCard
                icon={<FlaskConical className="h-5 w-5" />}
                color="bg-[#0A0A0F]"
                title="Analytics & A/B Testing"
                body="Track open rates, reply rates and click rates over time with visual charts. Compare how different email tones perform and double down on what converts."
              />
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section id="how" className="py-24 md:py-32 dark-section relative overflow-hidden">
        <div className="absolute inset-0 dot-bg-dark opacity-60 pointer-events-none" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#002FA7]/20 blur-3xl pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl mb-16">
            <div className="label-mono mb-3 text-white/50">— Workflow</div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight leading-tight text-white">
              Brief to first reply.<br />
              <span className="text-white/60">Under four minutes.</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
            {[
              { n: "01", t: "Define your ICP", b: "Niche, industry, geography, role titles. Plain English works. Or scrape a domain and skip this step entirely." },
              { n: "02", t: "AI builds your list", b: "Scored leads with emails, summaries, pain points, and LinkedIn URLs — in seconds. Enrich an existing CSV or surface funding-signal companies." },
              { n: "03", t: "Sequence & personalise", b: "Build a drip sequence or one-shot campaign. AI drafts every email in bulk, tone-tuned and hyper-personalised per lead." },
              { n: "04", t: "Send, track & iterate", b: "Ship through your verified domain. Track opens, replies, and clicks in real-time. A/B test tones. Find lookalikes from your best replies." },
            ].map((s, i) => (
              <div key={i} className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-8 hover:bg-white/[0.07] transition-colors">
                <div className="font-mono text-sm font-bold text-[#FF5722] mb-6">{s.n}</div>
                <div className="font-display text-2xl font-bold mb-3 text-white">{s.t}</div>
                <div className="text-white/60 leading-relaxed text-sm">{s.b}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl mb-16">
            <div className="label-mono mb-3">— Voices</div>
            <h2 className="font-display text-4xl md:text-5xl font-black tracking-tight leading-tight">
              Operators are replacing<br />
              <span className="text-[#5C5C66]">five tools with one.</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <Testimonial img={HEADSHOT_1} name="Avery Chen" role="Head of Growth · Northwind" stars={5} quote="Replaced Apollo + Lemlist + a freelance copywriter. Faster setup, better personalisation, lower spend." />
            <Testimonial img={HEADSHOT_2} name="Marcus Reyes" role="Founder · Lumeo" stars={5} quote="From signup to first reply in under an hour. The drafting engine reads our prospects' websites — feels handcrafted." featured />
            <Testimonial img={HEADSHOT_3} name="Sasha Patel" role="VP Sales · Meridian" stars={5} quote="Our SDR team uses it daily. Bulk send + per-lead Send button is exactly the workflow we wanted." />
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-24 md:py-32 bg-white border-t border-[#EAEAE3]">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-display text-5xl md:text-6xl font-black tracking-tighter leading-[0.95]">
            Build your first<br />
            <span className="text-[#002FA7]">prospect list today.</span>
          </h2>
          <p className="mt-6 text-[#5C5C66] text-lg max-w-xl mx-auto">
            Free trial. No credit card. Watch real prospects appear in your dashboard, scored and ready to ship.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/signup" data-testid="footer-cta-primary">
              <Button className="rounded-lg h-12 px-8 bg-[#0A0A0F] hover:bg-[#14141B] text-white text-base font-medium shadow-soft-md">
                Start free trial <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            <Link to="/pricing" data-testid="footer-cta-pricing">
              <Button variant="outline" className="rounded-lg h-12 px-8 border-[#EAEAE3] hover:bg-[#F4F4EE] text-base font-medium">
                Compare plans <ChevronRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}

function FeatureCard({ span, icon, kicker, title, body, feature }) {
  return (
    <div className={`${span} group relative rounded-2xl border border-[#EAEAE3] p-7 transition-all duration-300 hover:border-[#0A0A0F]/20 hover:-translate-y-0.5 ${feature ? "bg-white shadow-soft" : "bg-white"}`}>
      <div className="flex items-center gap-2.5 mb-5 text-[#0A0A0F]">
        <div className="w-9 h-9 rounded-lg bg-[#F4F4EE] flex items-center justify-center text-[#002FA7] group-hover:bg-[#002FA7] group-hover:text-white transition-colors">
          {icon}
        </div>
        <span className="label-mono">{kicker}</span>
      </div>
      <div className="font-display text-2xl md:text-[1.65rem] font-bold mb-3 tracking-tight leading-tight">{title}</div>
      <div className="text-[#5C5C66] leading-relaxed text-[0.95rem]">{body}</div>
    </div>
  );
}

function Testimonial({ img, name, role, quote, featured, stars = 5 }) {
  return (
    <div className={`rounded-2xl border p-7 transition-all duration-300 hover:-translate-y-0.5 ${featured ? "bg-[#0A0A0F] border-[#0A0A0F] text-white shadow-soft-md" : "bg-white border-[#EAEAE3]"}`}>
      <div className={`flex items-center gap-1 mb-4 ${featured ? "text-[#FF5722]" : "text-[#002FA7]"}`}>
        {Array.from({ length: stars }).map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}
      </div>
      <p className={`text-[0.95rem] leading-relaxed mb-6 ${featured ? "" : "text-[#0A0A0F]"}`}>"{quote}"</p>
      <div className="flex items-center gap-3">
        <img src={img} alt={name} className={`w-10 h-10 rounded-full object-cover ${featured ? "" : "grayscale"}`} />
        <div>
          <div className={`font-medium text-sm ${featured ? "text-white" : "text-[#0A0A0F]"}`}>{name}</div>
          <div className={`text-xs ${featured ? "text-white/60" : "text-[#5C5C66]"}`}>{role}</div>
        </div>
      </div>
    </div>
  );
}

function ToolCard({ icon, color, title, body }) {
  return (
    <div className="group bg-white border border-[#EAEAE3] rounded-2xl p-6 shadow-soft hover:shadow-soft-md hover:-translate-y-0.5 transition-all duration-300">
      <div className={`w-10 h-10 rounded-xl ${color} flex items-center justify-center text-white mb-4`}>
        {icon}
      </div>
      <div className="font-display text-lg font-bold tracking-tight mb-2">{title}</div>
      <div className="text-[#5C5C66] text-sm leading-relaxed">{body}</div>
    </div>
  );
}
